// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"8a0e2ac6","114":"54c38a23","296":"9b069f6e","327":"cb3211cc","387":"5e5540ac","516":"64e70395","970":"72f64a90"}[chunkId] + ".chunk.css";
};